"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_redux_1 = require("react-redux");
var CheckboxColumnComponent_1 = __importDefault(require("./CheckboxColumnComponent"));
var CheckboxHeaderContainer_1 = __importDefault(require("./CheckboxHeaderContainer"));
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var actions_1 = require("../../../actions");
var mapStateToProps = function (state, _a) {
    var grid = _a.grid, idx = _a.idx, rowData = _a.rowData;
    return ({
        checked: state.grid[grid] && state.grid[grid].selection &&
            state.grid[grid].selection.indexOf((0, find_in_object_1["default"])(idx, rowData)) !== -1
    });
};
var mapDispatchToProps = function (dispatch, _a) {
    var grid = _a.grid;
    return ({
        onChange: function (evt) { return dispatch((0, actions_1.changeSelection)(grid, evt.target)); }
    });
};
var CheckboxColumnContainer = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(CheckboxColumnComponent_1["default"]);
// @ts-ignore
CheckboxColumnContainer.defaultProps = {
    idx: 'id',
    ThComponent: CheckboxHeaderContainer_1["default"]
};
exports["default"] = CheckboxColumnContainer;
